import { render, staticRenderFns } from "./MenuPermissions.vue?vue&type=template&id=ec808d0a&scoped=true"
import script from "./MenuPermissions.vue?vue&type=script&lang=js"
export * from "./MenuPermissions.vue?vue&type=script&lang=js"
import style0 from "./MenuPermissions.vue?vue&type=style&index=0&id=ec808d0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec808d0a",
  null
  
)

export default component.exports